import {
  EOfferStatusData,
  EOfferStatusRequest,
  ERoomCounts,
  ELocations,
  ETypeFilterValues,
  ESpoilerCategoryRequest,
  ECategoryValue,
  ECategoryRequest,
  ERoomsCount,
  EActiveCategory,
} from 'shared/types/offersHistory';

/** Две одинаковые енамки по типам не подходят одна к другой из-за разных исходных имен, поэтому используем маппер */
export const mapOfferStatusEnums: Record<EOfferStatusData, EOfferStatusRequest> = {
  [EOfferStatusData.Published]: EOfferStatusRequest.Published,
  [EOfferStatusData.Deactivated]: EOfferStatusRequest.Deactivated,
};

export const mapOfferRoomsEnums: Record<ERoomCounts, ERoomsCount> = {
  [ERoomCounts.Five]: ERoomsCount.Five,
  [ERoomCounts.Four]: ERoomsCount.Four,
  [ERoomCounts.One]: ERoomsCount.One,
  [ERoomCounts.SixPlus]: ERoomsCount.SixPlus,
  [ERoomCounts.OnlyRoom]: ERoomsCount.OnlyRoom,
  [ERoomCounts.Studio]: ERoomsCount.Studio,
  [ERoomCounts.Three]: ERoomsCount.Three,
  [ERoomCounts.Two]: ERoomsCount.Two,
};

export const mapOfferLocationsEnums: Record<ELocations, ETypeFilterValues> = {
  [ELocations.NearbyHouses]: ETypeFilterValues.NearbyHouses,
  [ELocations.SameHouse]: ETypeFilterValues.SameHouse,
};

export const mapOfferSpoilerActiveCategoryEnums: Partial<Record<EActiveCategory, ESpoilerCategoryRequest>> = {
  [EActiveCategory.CottageSale]: ESpoilerCategoryRequest.CottageSale,
  [EActiveCategory.HouseSale]: ESpoilerCategoryRequest.HouseSale,
  [EActiveCategory.TownhouseSale]: ESpoilerCategoryRequest.TownhouseSale,
  [EActiveCategory.LandSale]: ESpoilerCategoryRequest.LandSale,
  [EActiveCategory.HouseShareSale]: ESpoilerCategoryRequest.HouseShareSale,
};

export const mapOfferSpoilerCategoryEnums: Partial<Record<ECategoryValue, ESpoilerCategoryRequest>> = {
  [ECategoryValue.CottageSale]: ESpoilerCategoryRequest.CottageSale,
  [ECategoryValue.HouseSale]: ESpoilerCategoryRequest.HouseSale,
  [ECategoryValue.TownhouseSale]: ESpoilerCategoryRequest.TownhouseSale,
  [ECategoryValue.LandSale]: ESpoilerCategoryRequest.LandSale,
  [ECategoryValue.HouseShareSale]: ESpoilerCategoryRequest.HouseShareSale,
};

export const mapOfferCategoriesEnums: Partial<Record<ESpoilerCategoryRequest, ECategoryRequest>> = {
  [ESpoilerCategoryRequest.CottageSale]: ECategoryRequest.CottageSale,
  [ESpoilerCategoryRequest.HouseSale]: ECategoryRequest.HouseSale,
  [ESpoilerCategoryRequest.TownhouseSale]: ECategoryRequest.TownhouseSale,
  [ESpoilerCategoryRequest.LandSale]: ECategoryRequest.LandSale,
  [ESpoilerCategoryRequest.HouseShareSale]: ECategoryRequest.HouseShareSale,
};
